<template>
 
    <section  v-if="data.statusFlash == 1"  class="landscape-tab-products4flash-wrap  container clearfix"  id="zoneflash"  :style="'opacity: 0; height: 0px; ' + data.bg_color">
        <div class="container">
            <div class="tab-products4flash-header clearfix">
                <h2 class="section-title float-left" v-html="data.title" style="margin-top: 25px;"></h2>

              
            </div>

            <div class="tab-content landscape-left-tab-products4flash">
                 <ProductCard v-for="(product, index) in JSON.parse(data.products)" :key="index" :product="product"></ProductCard>
            </div>

            <dynamic-tab v-for="(tabLabel, index) in data" :key="index" :label="tabLabel"
                :url="route('storefront.product_grid.index', { sectionNumber: 1, tabNumber: index + 1 })">
            </dynamic-tab>

            <div align="center" style="margin-top: 25px; margin-bottom: 25px; "><a :href="data.slug" class="btn btn-primary btn-deals">Découvrir</a></div>

        </div>
    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import DynamicTabsMixin from '../../mixins/DynamicTabsMixin';
import { slickPrevArrow, slickNextArrow } from '../../functions';

export default {
    components: { ProductCard },

    mixins: [
        DynamicTabsMixin,
    ],

    props: ['data'],

    methods: {
        selector() {
            return $('.landscape-left-tab-products4flash');
        },

        slickOptions() {
            return {
                rows: 0,
                dots: true,
                arrows: true,
                autoplay: true,
                speed: 5000,
                autoplay_speed: 5000,
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 6,
                rtl: window.FleetCart.rtl,
                /*       
                prevArrow: slickPrevArrow(),
                nextArrow: slickNextArrow(), 
                */
                responsive: [
                {
                            breakpoint: 1761,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5,
                            },
                        },
                        {
                            breakpoint: 1301,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            },
                        },
                        {
                            breakpoint: 1051,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            },
                        },
                        {
                            breakpoint: 881,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                        },
                        {
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                ],
            };
        },
    },
};
</script>

 